import { createBrowserHistory } from 'history';

// NOTE: this are being used for history.push inside the axios instance
export default createBrowserHistory({ basename: process.env.PUBLIC_URL });
